const stages = {
  CHOOSE: {
    number: 0,
    name: 'choose'
  },
  VERIFYING_PROOFS: {
    number: 1,
    name: 'verifying_proofs'
  },
  GENERATED_REPORTS: {
    number: 2,
    name: 'generated_reports'
  }
};
module.exports = stages;
